import React, { useEffect, useState } from "react";
import "./users.css";
import moment from "moment";
import Button from "../../../../ui/atoms/buttons/Button";
import NotFound from "../../../../ui/organisms/not-found/404";
import Loading from "../../../../ui/atoms/loading/Loading";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { capitalize, isEmpty, wait } from "../../../../core/utils/helpers";
import { onGetTeamMembers } from "../../services/user";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import { configurationSlice } from "../../../../app/store/slices/configurationSlice";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const Users = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [checkedTeamMember, setCheckedTeamMember] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const _localData = {
        rows_per_page: rowsPerPage,
        current_page: currentPage,
      };

      onGetTeamMembers(axiosPrivate, _localData, signal).then((response) => {
        const _data = response?.data;
        setTeamMembersData(_data);
      });

      setIsLoading(false);

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };

    fetchData();
  }, [rowsPerPage, currentPage]);

  const onHandleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
    setCheckedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
  };

  const onHandleSelectCurrentTeamMember = (team_member) => {
    setCheckedTeamMember((prevSelected) =>
      prevSelected.some((item) => item.id === team_member.id)
        ? prevSelected.filter((item) => item.id !== team_member.id)
        : [...prevSelected, team_member],
    );
  };

  const onHandleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allTeamMemberIds = teamMembersData?.result?.map((item) => item.id);
      setSelectedRows(allTeamMemberIds);
      setCheckedRows(allTeamMemberIds);
    } else {
      setSelectedRows([]);
      setCheckedRows([]);
    }
  };
  const isAllSelected =
    selectedRows?.length === teamMembersData?.result?.length;

  return (
    <div className="users">
      {isLoading ? (
        <Loading type={"type-2"} />
      ) : (
        <React.Fragment>
          <div className="user-head">
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"➕ Create new user"}
              action={() => navigate("/admin/users/create")}
            />
            {selectedRows.length > 0 && (
              <div className="u-actions fade-in">
                {selectedRows.length === 1 && (
                  <>
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"👁️ Voir details"}
                      action={() => {
                        dispatch(
                          configurationSlice.actions.onCurrentTeamMember(
                            checkedTeamMember[0],
                          ),
                        );
                        navigate(
                          `/admin/users/details?userId=${selectedRows[0]}`,
                        );
                      }}
                    />
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"🔄 Update infos"}
                      action={() => navigate("/admin/users/update")}
                    />
                  </>
                )}
                <Button
                  type={"button"}
                  preferedStyle={"default"}
                  title={"🔐 Activate or Desactivate account"}
                  action={() => {}}
                />
              </div>
            )}
          </div>
          <div className="user-body">
            {isEmpty(teamMembersData?.result) ? (
              <NotFound
                type={"data"}
                title={"No user found!"}
                text={"No User available yet."}
                isBoutton={false}
              />
            ) : (
              <>
                <div className="table">
                  <table>
                    <thead>
                      <tr>
                        <th className="col-05 text-align-center">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={onHandleSelectAll}
                          />
                        </th>
                        <th className="col-15 text-align-left">
                          Date of creation
                        </th>
                        <th className="col-40 text-align-left">Noms</th>
                        <th className="col-15 text-align-left">Téléphone</th>
                        <th className="col-10 text-align-left">System Role</th>
                        <th className="col-10 text-align-left">
                          Account Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {teamMembersData?.result?.map((item, idx) => {
                        return (
                          <tr
                            key={idx}
                            className={
                              checkedRows.includes(item.id) ? "row-checked" : ""
                            }
                          >
                            <td className="col-05 text-align-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(item.id)}
                                onChange={() => {
                                  onHandleSelectCurrentTeamMember(item);
                                  onHandleSelectRow(item.id);
                                }}
                              />
                            </td>
                            <td className="col-20 text-align-left">
                              {moment(item?.created_at).format("LLLL")}
                            </td>
                            <td className="col-35 text-align-left">
                              <div className="td-row">
                                <img
                                  src={
                                    isEmpty(item?.thumbnail)
                                      ? process.env.PUBLIC_URL + "/user.png"
                                      : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/${item?.thumbnail}`
                                  }
                                  alt={`P4MI acount of ${item?.firstname}-${item?.lastname}`}
                                />
                                <div className="td-col">
                                  <span className="span-names">
                                    {capitalize(item?.firstname)}{" "}
                                    {capitalize(item?.lastname)}
                                  </span>
                                  <span className="span-mail">
                                    {capitalize(item?.mail)}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="col-15 text-align-left">
                              {item?.telephone || "---"}
                            </td>
                            <td className="col-10 text-align-left">
                              <span className="span-role">
                                {item?.sys_role === "user"
                                  ? "System User"
                                  : "System Administration"}
                              </span>
                            </td>
                            <td className="col-10 text-align-left">
                              <StatusComponent
                                type={item?.is_activated ? "success" : "error"}
                                title={
                                  item?.is_activated ? "Active" : "Inactive"
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="pagination">
                  <div className="p-wrapper">
                    <button
                      className={
                        teamMembersData?.result_complements?.current_page === 1
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() => {
                        setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));
                        setSelectedRows([]);
                      }}
                      disabled={
                        teamMembersData?.result_complements?.current_page === 1
                      }
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of{" "}
                      {teamMembersData?.result_complements?.total_pages} pages.
                    </span>
                    <button
                      className={
                        teamMembersData?.result_complements?.current_page ===
                        teamMembersData?.result_complements?.total_pages
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() => {
                        setCurrentPage((prev) =>
                          prev <=
                          teamMembersData?.result_complements?.total_pages
                            ? prev + 1
                            : prev,
                        );
                        setSelectedRows([]);
                      }}
                      disabled={
                        teamMembersData?.result_complements?.current_page ===
                        teamMembersData?.result_complements?.total_pages
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Users;
